// @flow
import React from "react";
import BasicSelect from "../formElements/basicSelect/basicSelect";
import styles from "./componentWithSideMenu.scss";

type Props = {
  children?: React.Node,
  menuOptions: Array<any>,
  selectOption: Function,
  selectTopOption?: Function,
  topOption?: string,
  topSelectOptions?: Array<any>,
  onTopSelectChange?: Function,
  topSelectDefaultValue?: string
};

class ComponentWithSideMenu extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      selectedOpt:
        props.menuOptions && props.menuOptions.length && props.menuOptions[0].id // default selected option
    };
  }

  handleSelect(option) {
    this.setState(
      {
        selectedOpt: option && option.id
      },
      () => {
        this.props.selectOption(option);
      }
    );
  }

  handleTopButtonSelect() {
    this.setState({ selectedOpt: null }, () => {
      this.props.selectTopOption();
    });
  }

  changeSelect(val, event) {
    this.setState({ selectedOpt: 0 }, () => {
      this.props.onTopSelectChange(val, event);
    });
  }

  renderTopButton() {
    return (
      <div
        className={`${styles.optionButtonTop} j-center a-center cursor-p`}
        onClick={() => this.handleTopButtonSelect()}
      >
        <div className={styles.optionTextTop}>{this.props.topOption}</div>
      </div>
    );
  }

  renderTopSelect(options) {
    return (
      <div className={`${styles.select}`}>
        <BasicSelect
          label="Select Location"
          optionsArrOfObj={options}
          onSelect={(val, event) => {
            this.changeSelect(val, event);
          }}
          selectedOpt={this.props.topSelectDefaultValue || ""}
          enableSearch={true}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="l-row">
        <div className={styles.menu}>
          <div>
            {this.props.topSelectOptions
              ? this.renderTopSelect(this.props.topSelectOptions)
              : null}
            {this.props.topOption ? this.renderTopButton() : null}
            {this.props.menuOptions &&
              this.props.menuOptions.map((option, i) => (
                <div
                  className={
                    this.state.selectedOpt === (option && option.id)
                      ? styles.optionButtonSelected
                      : styles.optionButton
                  }
                  onClick={() => this.handleSelect(option)}
                  key={i}
                >
                  <div
                    className={
                      this.state.selectedOpt === (option && option.id)
                        ? styles.optionTextSelected
                        : styles.optionText
                    }
                  >
                    {option.name}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className={styles.mainComponent}>{this.props.children}</div>
      </div>
    );
  }
}

ComponentWithSideMenu.defaultProps = {
  children: "",
  topOption: null,
  selectTopOption: null,
  topSelectOptions: null,
  onTopSelectChange: null,
  topSelectDefaultValue: null
};

export default ComponentWithSideMenu;



// WEBPACK FOOTER //
// ./app/components/commons/componentWithSideMenu/componentWithSideMenu.js